export default "__VITE_ASSET__$7Ijdu4U__"